export {
  default,
  StyledIcon,
  StyledTimeFrom,
  StyledTitle,
  ITicketStatus,
} from './TicketStatus';
